// Libraries
import React from "react";
import { useObserver } from "mobx-react-lite";

// Custom
import { IEGridCategoryModel } from "../../IEmodels";
import { CommercialViewModel } from "../../Commercial.ViewModel";
import { PackagesViewModel } from "../../PackagesViewModel";
import { formatCurrencyForGrid, formatCurrencyNoSign } from "Utils/Format";

// Styling & Images
import { ToggleButton } from "../IEGrid.Styles";
import { formatCreditDebitClass, formatCreditDebitReverseClass, formatCreditVarianceDebitClass } from "Utils/Utils";
import { IEGridItemViewModel } from "../../IEmodels/IEGridItemViewModel";

interface ITableProps {
    itemModel: IEGridCategoryModel;
    rowType: string;
    rowIndex: number;
    sourceId: number;
    iEId: string;
    thisGuid: string;
    rowEnable(index: number): void;
    currentActiveCatIndex: number;
}

export const IECat: React.FunctionComponent<ITableProps> = (props) => {
    const { itemModel, rowType, sourceId, rowIndex, rowEnable, thisGuid, currentActiveCatIndex } = props;
    const packagesViewModel = PackagesViewModel.Instance;
    const commercialViewModel = CommercialViewModel.Instance;

    const formatDebit = (val: number) => {
        return commercialViewModel.formatDebit(val);
    };

    const handleName = () => {
        return packagesViewModel.getCategoryName(itemModel.sourceId);
    };

    return useObserver(() => (
        <>
            <li className={rowType} key={"cat_" + rowIndex}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ color: `${currentActiveCatIndex === rowIndex ? "#0095DA" : ""}`, paddingLeft: "5px" }} className="ie-row-name ie-cat-name" title={handleName()}>
                        {handleName()}
                    </span>
                    {currentActiveCatIndex === rowIndex ? (
                        <ToggleButton>
                            <span
                                className={"open"}
                                onClick={() => {
                                    rowEnable(-1);
                                }}
                            >
                                &minus;
                            </span>
                        </ToggleButton>
                    ) : (
                        <ToggleButton>
                            <span
                                className={"opcloseen"}
                                onClick={() => {
                                    rowEnable(rowIndex);
                                }}
                            >
                                &#43;
                            </span>
                        </ToggleButton>
                    )}
                </div>
                {!IEGridItemViewModel.Instance.isCentral && <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.income))}</div>}
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.estimateCost))}</div>
                {!IEGridItemViewModel.Instance.isCentral && <div className="right">{itemModel.margin}</div>}
                <div className={"right" + formatDebit(itemModel.committedCost)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.committedCost))}</div>
                {!IEGridItemViewModel.Instance.isCentral && <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.futureSpend))}</div>}
                {!IEGridItemViewModel.Instance.isCentral && <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.totalExpectedSpend))}</div>}
                <div className={"right" + formatCreditVarianceDebitClass(itemModel.getIEVariance, IEGridItemViewModel.Instance.isCentral)}>
                    {formatCurrencyForGrid(formatCurrencyNoSign(itemModel.getIEVariance))}
                </div>
                {!IEGridItemViewModel.Instance.isCentral && (
                    <div className={"right" + formatCreditDebitReverseClass(itemModel.roValue)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.roValue))}</div>
                )}
                <div className="right" style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}></div>
            </li>
        </>
    ));
};
